import { useEffect, useState } from "react";
import singleMemberLLCServices from "../../services/SingleMemberLLCService";
import { Modal, Select, Button, notification } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import Lodder from "../../components/Lodder";
import InputMask from "react-input-mask";
import { State } from "country-state-city";
import { CloseOutlined } from "@ant-design/icons";
const SingleMemberLLCForm = () => {
  //#region initialization
  const [id, setId] = useState("");
  const usStates = State.getStatesOfCountry("US").map((state) => ({
    value: state.name,
    label: state.name,
  }));
  const customerServiceId = useParams().customerServiceId;
  const [companyWithLLC, setCompanyWithLLC] = useState("");
  const [companyWithLLCValidation, setCompanyWithLLCValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleCompanyWithLLC = (event) => {
    setCompanyWithLLC(event.target.value);
    ValidateCompanyWithLLC(event.target.value);
  };
  const ValidateCompanyWithLLC = (value) => {
    if (!value.trim() && isSubmitted) {
      setCompanyWithLLCValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setCompanyWithLLCValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else {
      setCompanyWithLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [primaryBusiness, setPrimaryBusiness] = useState("");
  const [primaryBusinessValidation, setPrimaryBusinessValidation] = useState({
    isValid: true,
    message: "",
  });
  const handlePrimaryBusiness = (event) => {
    setPrimaryBusiness(event.target.value);
    ValidatePrimaryBusiness(event.target.value);
  };
  const ValidatePrimaryBusiness = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrimaryBusinessValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setPrimaryBusinessValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else {
      setPrimaryBusinessValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [principalAddressLine1, setPrincipalAddressLine1] = useState("");
  const [principalAddressLine1Validation, setPrincipalAddressLine1Validation] =
    useState({
      isValid: true,
      message: "",
    });
  const handlePrincipalAddressLine1 = (event) => {
    setPrincipalAddressLine1(event.target.value);
    ValidatePrincipalAddressLine1(event.target.value);
  };
  const ValidatePrincipalAddressLine1 = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrincipalAddressLine1Validation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100) {
      setPrincipalAddressLine1Validation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setPrincipalAddressLine1Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [principalAddressLine2, setPrincipalAddressLine2] = useState("");
  const [principalAddressLine2Validation, setPrincipalAddressLine2Validation] =
    useState({
      isValid: true,
      message: "",
    });
  const handlePrincipalAddressLine2 = (event) => {
    setPrincipalAddressLine2(event.target.value);
    ValidatePrincipalAddressLine2(event.target.value);
  };
  const ValidatePrincipalAddressLine2 = (value) => {
    if (value.length > 100) {
      setPrincipalAddressLine2Validation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setPrincipalAddressLine2Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [principalAddressCity, setPrincipalAddressCity] = useState("");
  const [principalAddressCityValidation, setPrincipalAddressCityValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handlePrincipalAddressCity = (event) => {
    setPrincipalAddressCity(event.target.value);
    ValidatePrincipalAddressCity(event.target.value);
  };
  const ValidatePrincipalAddressCity = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrincipalAddressCityValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100) {
      setPrincipalAddressCityValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setPrincipalAddressCityValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [principalAddressState, setPrincipalAddressState] =
    useState("Washington");
  const [principalAddressStateValidation, setPrincipalAddressStateValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handlePrincipalAddressState = (selectedOption) => {
    setPrincipalAddressState(selectedOption);
    ValidatePrincipalAddressState(selectedOption);
  };
  const ValidatePrincipalAddressState = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrincipalAddressStateValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100) {
      setPrincipalAddressStateValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setPrincipalAddressStateValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [principalAddressZipCode, setPrincipalAddressZipCode] = useState("");
  const [
    principalAddressZipCodeValidation,
    setPrincipalAddressZipCodeValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handlePrincipalAddressZipCode = (event) => {
    setPrincipalAddressZipCode(event.target.value);
    ValidatePrincipalAddressZipCode(event.target.value);
  };
  const ValidatePrincipalAddressZipCode = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrincipalAddressZipCodeValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (!/^\d{5}$/.test(value) && isSubmitted) {
      setPrincipalAddressZipCodeValidation({
        isValid: false,
        message: "Please enter a valid zip code",
      });
      return false;
    } else {
      setPrincipalAddressZipCodeValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isSeparateMailingAddress, setIsSeparateMailingAddress] = useState("");
  const [
    isSeparateMailingAddressValidation,
    setIsSeparateMailingAddressValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handleIsSeparateMailingAddress = (event) => {
    setIsSeparateMailingAddress(event.target.value);
    ValidateIsSeparateMailingAddress(event.target.value);
  };
  const ValidateIsSeparateMailingAddress = (value) => {
    if (!value.trim() && isSubmitted) {
      setIsSeparateMailingAddressValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setIsSeparateMailingAddressValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [mailingAddressLine1, setMailingAddressLine1] = useState("");
  const [mailingAddressLine1Validation, setMailingAddressLine1Validation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleMailingAddressLine1 = (event) => {
    setMailingAddressLine1(event.target.value);
    ValidateMailingAddressLine1(event.target.value);
  };
  const ValidateMailingAddressLine1 = (value) => {
    if (!value.trim() && isSeparateMailingAddress === "true" && isSubmitted) {
      setMailingAddressLine1Validation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100 && isSeparateMailingAddress === "true") {
      setMailingAddressLine1Validation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setMailingAddressLine1Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [mailingAddressLine2, setMailingAddressLine2] = useState("");
  const [mailingAddressLine2Validation, setMailingAddressLine2Validation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleMailingAddressLine2 = (event) => {
    setMailingAddressLine2(event.target.value);
    ValidateMailingAddressLine2(event.target.value);
  };
  const ValidateMailingAddressLine2 = (value) => {
    if (value.length > 100 && isSeparateMailingAddress === "true") {
      setMailingAddressLine2Validation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setMailingAddressLine2Validation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [mailingAddressCity, setMailingAddressCity] = useState("");
  const [mailingAddressCityValidation, setMailingAddressCityValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleMailingAddressCity = (event) => {
    setMailingAddressCity(event.target.value);
    ValidateMailingAddressCity(event.target.value);
  };
  const ValidateMailingAddressCity = (value) => {
    if (!value.trim() && isSeparateMailingAddress === "true" && isSubmitted) {
      setMailingAddressCityValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100 && isSeparateMailingAddress === "true") {
      setMailingAddressCityValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setMailingAddressCityValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [mailingAddressState, setMailingAddressState] = useState("Washington");
  const [mailingAddressStateValidation, setMailingAddressStateValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleMailingAddressState = (selectedOption) => {
    setMailingAddressState(selectedOption);
    ValidateMailingAddressState(selectedOption);
  };
  const ValidateMailingAddressState = (value) => {
    if (!value.trim() && isSeparateMailingAddress === "true" && isSubmitted) {
      setMailingAddressStateValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100 && isSeparateMailingAddress === "true") {
      setMailingAddressStateValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else {
      setMailingAddressStateValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [mailingAddressZipCode, setMailingAddressZipCode] = useState("");
  const [mailingAddressZipCodeValidation, setMailingAddressZipCodeValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleMailingAddressZipCode = (event) => {
    setMailingAddressZipCode(event.target.value);
    ValidateMailingAddressZipCode(event.target.value);
  };
  const ValidateMailingAddressZipCode = (value) => {
    if (!value.trim() && isSeparateMailingAddress === "true" && isSubmitted) {
      setMailingAddressZipCodeValidation({
        isValid: false,
        message: "This feild is required",
      });
      return false;
    } else if (
      !/^\d{5}$/.test(value) &&
      isSeparateMailingAddress === "true" &&
      isSubmitted
    ) {
      setMailingAddressZipCodeValidation({
        isValid: false,
        message: "Please enter a valid zip code",
      });
      return false;
    } else {
      setMailingAddressZipCodeValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [ownerFirstName, setOwnerFirstName] = useState("");
  const [ownerFirstNameValidation, setOwnerFirstNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleOwnerFirstName = (event) => {
    setOwnerFirstName(event.target.value);
    ValidateOwnerFirstName(event.target.value);
  };
  const ValidateOwnerFirstName = (value) => {
    if (!value.trim() && isSubmitted) {
      setOwnerFirstNameValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 50) {
      setOwnerFirstNameValidation({
        isValid: false,
        message: "Don't enter more than 50 character",
      });
      return false;
    } else {
      setOwnerFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [ownerLastName, setOwnerLastName] = useState("");
  const [ownerLastNameValidation, setOwnerLastNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleOwnerLastName = (event) => {
    setOwnerLastName(event.target.value);
    ValidateOwnerLastName(event.target.value);
  };
  const ValidateOwnerLastName = (value) => {
    if (!value.trim() && isSubmitted) {
      setOwnerLastNameValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 50) {
      setOwnerLastNameValidation({
        isValid: false,
        message: "Don't enter more than 50 character",
      });
      return false;
    } else {
      setOwnerLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [
    preferredContactEmailForBusiness,
    setPreferredContactEmailForBusiness,
  ] = useState("");
  const [
    preferredContactEmailForBusinessValidation,
    setPreferredContactEmailForBusinessValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handlePreferredContactEmailForBusiness = (event) => {
    setPreferredContactEmailForBusiness(event.target.value);
    ValidatePreferredContactEmailForBusiness(event.target.value);
  };
  const ValidatePreferredContactEmailForBusiness = (value) => {
    if (!value.trim() && isSubmitted) {
      setPreferredContactEmailForBusinessValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100) {
      setPreferredContactEmailForBusinessValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else if (!IsValidEmail(value)) {
      setPreferredContactEmailForBusinessValidation({
        isValid: false,
        message: "Please enter a valid email",
      });
      return false;
    } else {
      setPreferredContactEmailForBusinessValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [
    preferredContactEmailForReceivingUpdates,
    setPreferredContactEmailForReceivingUpdates,
  ] = useState("");
  const [
    preferredContactEmailForReceivingUpdatesValidation,
    setPreferredContactEmailForReceivingUpdatesValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handlePreferredContactEmailForReceivingUpdates = (event) => {
    setPreferredContactEmailForReceivingUpdates(event.target.value);
    ValidatePreferredContactEmailForReceivingUpdates(event.target.value);
  };
  const ValidatePreferredContactEmailForReceivingUpdates = (value) => {
    if (!value.trim() && isSubmitted) {
      setPreferredContactEmailForReceivingUpdatesValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100) {
      setPreferredContactEmailForReceivingUpdatesValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else if (!IsValidEmail(value)) {
      setPreferredContactEmailForReceivingUpdatesValidation({
        isValid: false,
        message: "Please enter a valid email",
      });
      return false;
    } else {
      setPreferredContactEmailForReceivingUpdatesValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [preferredPhoneNumber, setPreferredPhoneNumber] = useState("");
  const [preferredPhoneNumberValidation, setPreferredPhoneNumberValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handlePreferredPhoneNumber = (event) => {
    setPreferredPhoneNumber(event.target.value);
    ValidatePreferredPhoneNumber(event.target.value);
  };
  const ValidatePreferredPhoneNumber = (value) => {
    if (!value.trim() && isSubmitted) {
      setPreferredPhoneNumberValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 20) {
      setPreferredPhoneNumberValidation({
        isValid: false,
        message: "Don't enter more than 20 character",
      });
      return false;
    } else {
      setPreferredPhoneNumberValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isEffectiveDateForCreating, setIsEffectiveDateForCreating] =
    useState("");
  const [
    isEffectiveDateForCreatingValidation,
    setIsEffectiveDateForCreatingValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handleIsEffectiveDateForCreating = (event) => {
    setIsEffectiveDateForCreating(event.target.value);
    ValidateIsEffectiveDateForCreating(event.target.value);
  };
  const ValidateIsEffectiveDateForCreating = (value) => {
    if (!value.trim() && isSubmitted) {
      setIsEffectiveDateForCreatingValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setIsEffectiveDateForCreatingValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [effectiveDateForLLC, setEffectiveDateForLLC] = useState("");
  const [effectiveDateForLLCValidation, setEffectiveDateForLLCValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleEffectiveDateForLLC = (event) => {
    setEffectiveDateForLLC(event.target.value);
    ValidateEffectiveDateForLLC(event.target.value);
  };
  const ValidateEffectiveDateForLLC = (value) => {
    if (isEffectiveDateForCreating === "false") {
      if (!value.trim() && isSubmitted) {
        setEffectiveDateForLLCValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 100) {
        setEffectiveDateForLLCValidation({
          isValid: false,
          message: "Don't enter more than 100 character",
        });
        return false;
      } else {
        setEffectiveDateForLLCValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setEffectiveDateForLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [reasonForEffectiveDate, setReasonForEffectiveDate] = useState("");
  const [
    reasonForEffectiveDateValidation,
    setReasonForEffectiveDateValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handleReasonForEffectiveDate = (event) => {
    setReasonForEffectiveDate(event.target.value);
    ValidateReasonForEffectiveDate(event.target.value);
  };
  const ValidateReasonForEffectiveDate = (value) => {
    if (isEffectiveDateForCreating === "false") {
      if (!value.trim() && isSubmitted) {
        setReasonForEffectiveDateValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setReasonForEffectiveDateValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setReasonForEffectiveDateValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setReasonForEffectiveDateValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [perpetualTermForTheLLC, setPerpetualTermForTheLLC] = useState("");
  const [
    perpetualTermForTheLLCValidation,
    setPerpetualTermForTheLLCValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handlePerpetualTermForTheLLC = (event) => {
    setPerpetualTermForTheLLC(event.target.value);
    ValidatePerpetualTermForTheLLC(event.target.value);
  };
  const ValidatePerpetualTermForTheLLC = (value) => {
    if (!value.trim() && isSubmitted) {
      setPerpetualTermForTheLLCValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setPerpetualTermForTheLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [termOfLLC, setTermOfLLC] = useState("");
  const [termOfLLCValidation, setTermOfLLCValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleTermOfLLC = (event) => {
    setTermOfLLC(event.target.value);
    ValidateTermOfLLC(event.target.value);
  };
  const ValidateTermOfLLC = (value) => {
    if (perpetualTermForTheLLC === "2") {
      if (!value.trim() && isSubmitted) {
        setTermOfLLCValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setTermOfLLCValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setTermOfLLCValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setTermOfLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [reasonTermOfLLC, setReasonTermOfLLC] = useState("");
  const [reasonTermOfLLCValidation, setReasonTermOfLLCValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleReasonTermOfLLC = (event) => {
    setReasonTermOfLLC(event.target.value);
    ValidateReasonTermOfLLC(event.target.value);
  };
  const ValidateReasonTermOfLLC = (value) => {
    if (perpetualTermForTheLLC === "2") {
      if (!value.trim() && isSubmitted) {
        setReasonTermOfLLCValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setReasonTermOfLLCValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setReasonTermOfLLCValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setReasonTermOfLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isCash, setIsCash] = useState(false);
  const handleIsCash = () => {
    if (
      isSubmitted &&
      isCash &&
      !isIntellectualProperty &&
      !isOtherAssets &&
      !isService &&
      !isOther
    ) {
      setContributingToTheCompanyValidation({
        isValid: false,
        message: "This field is required",
      });
    } else {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
    }
    setIsCash(!isCash);
  };
  const [amountOfCash, setAmountOfCash] = useState("");
  const [amountOfCashValidation, setAmountOfCashValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleAmountOfCash = (event) => {
    setAmountOfCash(event.target.value);
    ValidateAmountOfCash(event.target.value);
  };
  const ValidateAmountOfCash = (value) => {
    if (!value.trim() && isSubmitted && isCash) {
      setAmountOfCashValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setAmountOfCashValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isIntellectualProperty, setIsIntellectualProperty] = useState(false);
  const handleIsIntellectualProperty = () => {
    if (
      isSubmitted &&
      !isCash &&
      isIntellectualProperty &&
      !isOtherAssets &&
      !isService &&
      !isOther
    ) {
      setContributingToTheCompanyValidation({
        isValid: false,
        message: "This field is required",
      });
    } else {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
    }
    setIsIntellectualProperty(!isIntellectualProperty);
  };
  const [intellectualProperty, setIntellectualProperty] = useState("");
  const [intellectualPropertyValidation, setIntellectualPropertyValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleIntellectualProperty = (event) => {
    setIntellectualProperty(event.target.value);
    ValidateIntellectualProperty(event.target.value);
  };
  const ValidateIntellectualProperty = (value) => {
    if (!value.trim() && isSubmitted && isIntellectualProperty) {
      setIntellectualPropertyValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setIntellectualPropertyValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isOtherAssets, setIsOtherAssets] = useState(false);
  const handleIsOtherAssets = () => {
    if (
      isSubmitted &&
      !isCash &&
      !isIntellectualProperty &&
      isOtherAssets &&
      !isService &&
      !isOther
    ) {
      setContributingToTheCompanyValidation({
        isValid: false,
        message: "This field is required",
      });
    } else {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
    }
    setIsOtherAssets(!isOtherAssets);
  };
  const [otherAssets, setOtherAssets] = useState("");
  const [otherAssetsValidation, setOtherAssetsValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleOtherAssets = (event) => {
    setOtherAssets(event.target.value);
    ValidateOtherAssets(event.target.value);
  };
  const ValidateOtherAssets = (value) => {
    if (!value.trim() && isSubmitted && isOtherAssets) {
      setOtherAssetsValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setOtherAssetsValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isService, setIsService] = useState(false);
  const handleIsService = () => {
    if (
      isSubmitted &&
      !isCash &&
      !isIntellectualProperty &&
      !isOtherAssets &&
      isService &&
      !isOther
    ) {
      setContributingToTheCompanyValidation({
        isValid: false,
        message: "This field is required",
      });
    } else {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
    }
    setIsService(!isService);
  };
  const [isOther, setIsOther] = useState(false);
  const handleIsOther = () => {
    if (
      isSubmitted &&
      !isCash &&
      !isIntellectualProperty &&
      !isOtherAssets &&
      !isService &&
      isOther
    ) {
      setContributingToTheCompanyValidation({
        isValid: false,
        message: "This field is required",
      });
    } else {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
    }
    setIsOther(!isOther);
  };
  const [other, setOther] = useState("");
  const [otherValidation, setOtherValidation] = useState({
    isValid: true,
    message: "",
  });
  const handleOther = (event) => {
    setOther(event.target.value);
    ValidateOther(event.target.value);
  };
  const ValidateOther = (value) => {
    if (!value.trim() && isSubmitted && isOther) {
      setOtherValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setOtherValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [haveIntellectualProperty, setHaveIntellectualProperty] = useState("");
  const [
    haveIntellectualPropertyValidation,
    setHaveIntellectualPropertyValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handleHaveIntellectualProperty = (event) => {
    setHaveIntellectualProperty(event.target.value);
    ValidateHaveIntellectualProperty(event.target.value);
  };
  const ValidateHaveIntellectualProperty = (value) => {
    if (!value.trim() && isSubmitted) {
      setHaveIntellectualPropertyValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setHaveIntellectualPropertyValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [describeIntellectualProperty, setDescribeIntellectualProperty] =
    useState("");
  const [
    describeIntellectualPropertyValidation,
    setDescribeIntellectualPropertyValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handleDescribeIntellectualProperty = (event) => {
    setDescribeIntellectualProperty(event.target.value);
    ValidateDescribeIntellectualProperty(event.target.value);
  };
  const ValidateDescribeIntellectualProperty = (value) => {
    if (haveIntellectualProperty == 1) {
      if (!value.trim() && isSubmitted) {
        setDescribeIntellectualPropertyValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setDescribeIntellectualPropertyValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setDescribeIntellectualPropertyValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setDescribeIntellectualPropertyValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [optionForRegisteredAgent, setOptionForRegisteredAgent] = useState("");
  const [
    optionForRegisteredAgentValidation,
    setOptionForRegisteredAgentValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const handleOptionForRegisteredAgent = (event) => {
    setOptionForRegisteredAgent(event.target.value);
    ValidateOptionForRegisteredAgent(event.target.value);
  };
  const ValidateOptionForRegisteredAgent = (value) => {
    if (!value.trim() && isSubmitted) {
      setOptionForRegisteredAgentValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setOptionForRegisteredAgentValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [otherRegisteredAgent, setOtherRegisteredAgent] = useState("");
  const [otherRegisteredAgentValidation, setOtherRegisteredAgentValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleOtherRegisteredAgent = (event) => {
    setOtherRegisteredAgent(event.target.value);
    ValidateOtherRegisteredAgent(event.target.value);
  };
  const ValidateOtherRegisteredAgent = (value) => {
    if (optionForRegisteredAgent === "3") {
      if (!value.trim() && isSubmitted) {
        setOtherRegisteredAgentValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setOtherRegisteredAgentValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setOtherRegisteredAgentValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setOtherRegisteredAgentValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [
    contributingToTheCompanyValidation,
    setContributingToTheCompanyValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const ValidateContributingToTheCompany = () => {
    if (
      isCash ||
      isIntellectualProperty ||
      isOtherAssets ||
      isService ||
      isOther
    ) {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
      return true;
    } else if (isSubmitted) {
      setContributingToTheCompanyValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setContributingToTheCompanyValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [toggle, setToggle] = useState(1);
  const [toggle2, setToggle2] = useState(1);
  const [readOnly, setReadOnly] = useState(false);

  //#endregion

  useEffect(() => {
    if (toggle !== 1) {
      ValidateOtherRegisteredAgent(otherRegisteredAgent);
      ValidateOptionForRegisteredAgent(optionForRegisteredAgent);
      ValidateReasonTermOfLLC(reasonTermOfLLC);
      ValidateTermOfLLC(termOfLLC);
      ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC);
      ValidateReasonForEffectiveDate(reasonForEffectiveDate);
      ValidateEffectiveDateForLLC(effectiveDateForLLC);
      ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating);
      ValidatePreferredPhoneNumber(preferredPhoneNumber);
      ValidateIsSeparateMailingAddress(isSeparateMailingAddress);
      ValidatePrimaryBusiness(primaryBusiness);
      ValidateCompanyWithLLC(companyWithLLC);
      if (
        ValidateOtherRegisteredAgent(otherRegisteredAgent) &&
        ValidateOptionForRegisteredAgent(optionForRegisteredAgent) &&
        ValidateReasonTermOfLLC(reasonTermOfLLC) &&
        ValidateTermOfLLC(termOfLLC) &&
        ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC) &&
        ValidateReasonForEffectiveDate(reasonForEffectiveDate) &&
        ValidateEffectiveDateForLLC(effectiveDateForLLC) &&
        ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating) &&
        ValidatePreferredPhoneNumber(preferredPhoneNumber) &&
        ValidateIsSeparateMailingAddress(isSeparateMailingAddress) &&
        ValidatePrimaryBusiness(primaryBusiness) &&
        ValidateCompanyWithLLC(companyWithLLC)
      ) {
        handleSubmit();
      }
      setIsSubmitted(false);
    }
  }, [toggle]);
  useEffect(() => {
    if (toggle2 !== 1) {
      ValidateContributingToTheCompany();
      ValidateOtherRegisteredAgent(otherRegisteredAgent);
      ValidateOptionForRegisteredAgent(optionForRegisteredAgent);
      ValidateDescribeIntellectualProperty(describeIntellectualProperty);
      ValidateHaveIntellectualProperty(haveIntellectualProperty);
      ValidateReasonTermOfLLC(reasonTermOfLLC);
      ValidateTermOfLLC(termOfLLC);
      ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC);
      ValidateReasonForEffectiveDate(reasonForEffectiveDate);
      ValidateEffectiveDateForLLC(effectiveDateForLLC);
      ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating);
      ValidatePreferredPhoneNumber(preferredPhoneNumber);
      ValidatePreferredContactEmailForReceivingUpdates(
        preferredContactEmailForReceivingUpdates
      );
      ValidatePreferredContactEmailForBusiness(
        preferredContactEmailForBusiness
      );
      ValidateOwnerLastName(ownerLastName);
      ValidateOwnerFirstName(ownerFirstName);
      ValidateMailingAddressZipCode(mailingAddressZipCode);
      ValidateMailingAddressState(mailingAddressState);
      ValidateMailingAddressCity(mailingAddressCity);
      ValidateMailingAddressLine2(mailingAddressLine2);
      ValidateMailingAddressLine1(mailingAddressLine1);
      ValidateIsSeparateMailingAddress(isSeparateMailingAddress);
      ValidatePrincipalAddressZipCode(principalAddressZipCode);
      ValidatePrincipalAddressState(principalAddressState);
      ValidatePrincipalAddressCity(principalAddressCity);
      ValidatePrincipalAddressLine2(principalAddressLine2);
      ValidatePrincipalAddressLine1(principalAddressLine1);
      ValidatePrimaryBusiness(primaryBusiness);
      ValidateCompanyWithLLC(companyWithLLC);
      ValidateAmountOfCash(amountOfCash);
      ValidateIntellectualProperty(intellectualProperty);
      ValidateOtherAssets(otherAssets);
      ValidateOther(other);
      if (
        ValidateOtherRegisteredAgent(otherRegisteredAgent) &&
        ValidateOptionForRegisteredAgent(optionForRegisteredAgent) &&
        ValidateDescribeIntellectualProperty(describeIntellectualProperty) &&
        ValidateHaveIntellectualProperty(haveIntellectualProperty) &&
        ValidateReasonTermOfLLC(reasonTermOfLLC) &&
        ValidateTermOfLLC(termOfLLC) &&
        ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC) &&
        ValidateReasonForEffectiveDate(reasonForEffectiveDate) &&
        ValidateEffectiveDateForLLC(effectiveDateForLLC) &&
        ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating) &&
        ValidatePreferredPhoneNumber(preferredPhoneNumber) &&
        ValidatePreferredContactEmailForReceivingUpdates(
          preferredContactEmailForReceivingUpdates
        ) &&
        ValidatePreferredContactEmailForBusiness(
          preferredContactEmailForBusiness
        ) &&
        ValidateOwnerLastName(ownerLastName) &&
        ValidateOwnerFirstName(ownerFirstName) &&
        ValidateMailingAddressZipCode(mailingAddressZipCode) &&
        ValidateMailingAddressState(mailingAddressState) &&
        ValidateMailingAddressCity(mailingAddressCity) &&
        ValidateMailingAddressLine2(mailingAddressLine2) &&
        ValidateMailingAddressLine1(mailingAddressLine1) &&
        ValidateIsSeparateMailingAddress(isSeparateMailingAddress) &&
        ValidatePrincipalAddressZipCode(principalAddressZipCode) &&
        ValidatePrincipalAddressState(principalAddressState) &&
        ValidatePrincipalAddressCity(principalAddressCity) &&
        ValidatePrincipalAddressLine2(principalAddressLine2) &&
        ValidatePrincipalAddressLine1(principalAddressLine1) &&
        ValidatePrimaryBusiness(primaryBusiness) &&
        ValidateCompanyWithLLC(companyWithLLC) &&
        ValidateContributingToTheCompany() &&
        ValidateAmountOfCash(amountOfCash) &&
        ValidateIntellectualProperty(intellectualProperty) &&
        ValidateOtherAssets(otherAssets) &&
        ValidateOther(other)
      ) {
        setOpen(true);
      }
    }
  }, [toggle2]);

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setIsSubmitted(true);
    setToggle2(toggle2 + 1);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const handleOk = () => {
    setOpen(false);
    setToggle(toggle + 1);
    setIsSubmitted(true);
  };
  useEffect(() => {
    singleMemberLLCServices
      .GetCustomerServiceQuestionByCustomerServiceId(customerServiceId)
      .then((response) => {
        if (response.status) {
          const { resultData } = response;
          if (resultData !== null) {
            setReadOnly(resultData.isSubmitted);
            setId(resultData.id);
            setCompanyWithLLC(resultData.companyWithLLC);
            setPrimaryBusiness(resultData.primaryBusiness);
            setPrincipalAddressLine1(resultData.principalAddressLine1);
            setPrincipalAddressLine2(resultData.principalAddressLine2);
            setPrincipalAddressCity(resultData.principalAddressCity);
            setPrincipalAddressState(resultData.principalAddressState);
            setPrincipalAddressZipCode(resultData.principalAddressZipCode);
            setIsSeparateMailingAddress(
              resultData.isSeparateMailingAddress.toString()
            );
            if (resultData.isSeparateMailingAddress) {
              setMailingAddressLine1(resultData.mailingAddressLine1);
              setMailingAddressLine2(resultData.mailingAddressLine2);
              setMailingAddressCity(resultData.mailingAddressCity);
              setMailingAddressState(resultData.mailingAddressState);
              setMailingAddressZipCode(resultData.mailingAddressZipCode);
            }
            setOwnerFirstName(resultData.ownerFirstName);
            setOwnerLastName(resultData.ownerLastName);
            setPreferredContactEmailForBusiness(
              resultData.preferredContactEmailForBusiness
            );
            setPreferredContactEmailForReceivingUpdates(
              resultData.preferredContactEmailForReceivingUpdates
            );
            setPreferredPhoneNumber(resultData.preferredPhoneNumber);
            setIsEffectiveDateForCreating(
              resultData.isEffectiveDateForCreating.toString()
            );
            if (!resultData.isEffectiveDateForCreating) {
              setEffectiveDateForLLC(resultData.effectiveDateForLLC);
              setReasonForEffectiveDate(resultData.reasonForEffectiveDate);
            }
            setPerpetualTermForTheLLC(
              resultData.perpetualTermForTheLLC.toString()
            );
            if (resultData.perpetualTermForTheLLC === 2) {
              setTermOfLLC(resultData.termOfLLC);
              setReasonTermOfLLC(resultData.reasonTermOfLLC);
            }
            setIsCash(resultData.isCash);
            if (resultData.isCash) {
              setAmountOfCash(resultData.amountOfCash);
            }
            setIsIntellectualProperty(resultData.isIntellectualProperty);
            if (resultData.isIntellectualProperty) {
              setIntellectualProperty(resultData.intellectualProperty);
            }
            setIsOtherAssets(resultData.isOtherAssets);
            if (resultData.isOtherAssets) {
              setOtherAssets(resultData.otherAssets);
            }
            setIsService(resultData.isService);
            setIsOther(resultData.isOther);
            if (resultData.isOther) {
              setOther(resultData.other);
            }
            setHaveIntellectualProperty(
              resultData.haveIntellectualProperty.toString()
            );
            if (resultData.haveIntellectualProperty) {
              setDescribeIntellectualProperty(
                resultData.describeIntellectualProperty
              );
            }
            setOptionForRegisteredAgent(
              resultData.optionForRegisteredAgent.toString()
            );
            if (resultData.optionForRegisteredAgent == 3) {
              setOtherRegisteredAgent(resultData.otherRegisteredAgent);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    document.title = "Foundry Law - Single Member LLC Form";
  }, []);
  const IsValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const handleSubmit = () => {
    setShow(true);
    ValidateOtherRegisteredAgent(otherRegisteredAgent);
    ValidateOptionForRegisteredAgent(optionForRegisteredAgent);
    ValidateDescribeIntellectualProperty(describeIntellectualProperty);
    ValidateHaveIntellectualProperty(haveIntellectualProperty);
    ValidateReasonTermOfLLC(reasonTermOfLLC);
    ValidateTermOfLLC(termOfLLC);
    ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC);
    ValidateReasonForEffectiveDate(reasonForEffectiveDate);
    ValidateEffectiveDateForLLC(effectiveDateForLLC);
    ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating);
    ValidatePreferredPhoneNumber(preferredPhoneNumber);
    ValidatePreferredContactEmailForReceivingUpdates(
      preferredContactEmailForReceivingUpdates
    );
    ValidatePreferredContactEmailForBusiness(preferredContactEmailForBusiness);
    ValidateOwnerLastName(ownerLastName);
    ValidateOwnerFirstName(ownerFirstName);
    ValidateMailingAddressZipCode(mailingAddressZipCode);
    ValidateMailingAddressState(mailingAddressState);
    ValidateMailingAddressCity(mailingAddressCity);
    ValidateMailingAddressLine2(mailingAddressLine2);
    ValidateMailingAddressLine1(mailingAddressLine1);
    ValidateIsSeparateMailingAddress(isSeparateMailingAddress);
    ValidatePrincipalAddressZipCode(principalAddressZipCode);
    ValidatePrincipalAddressState(principalAddressState);
    ValidatePrincipalAddressCity(principalAddressCity);
    ValidatePrincipalAddressLine2(principalAddressLine2);
    ValidatePrincipalAddressLine1(principalAddressLine1);
    ValidatePrimaryBusiness(primaryBusiness);
    ValidateCompanyWithLLC(companyWithLLC);
    ValidateContributingToTheCompany();
    ValidateAmountOfCash(amountOfCash);
    ValidateIntellectualProperty(intellectualProperty);
    ValidateOtherAssets(otherAssets);
    ValidateOther(other);
    if (
      ValidateOtherRegisteredAgent(otherRegisteredAgent) &&
      ValidateOptionForRegisteredAgent(optionForRegisteredAgent) &&
      ValidateDescribeIntellectualProperty(describeIntellectualProperty) &&
      ValidateHaveIntellectualProperty(haveIntellectualProperty) &&
      ValidateReasonTermOfLLC(reasonTermOfLLC) &&
      ValidateTermOfLLC(termOfLLC) &&
      ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC) &&
      ValidateReasonForEffectiveDate(reasonForEffectiveDate) &&
      ValidateEffectiveDateForLLC(effectiveDateForLLC) &&
      ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating) &&
      ValidatePreferredPhoneNumber(preferredPhoneNumber) &&
      ValidatePreferredContactEmailForReceivingUpdates(
        preferredContactEmailForReceivingUpdates
      ) &&
      ValidatePreferredContactEmailForBusiness(
        preferredContactEmailForBusiness
      ) &&
      ValidateOwnerLastName(ownerLastName) &&
      ValidateOwnerFirstName(ownerFirstName) &&
      ValidateMailingAddressZipCode(mailingAddressZipCode) &&
      ValidateMailingAddressState(mailingAddressState) &&
      ValidateMailingAddressCity(mailingAddressCity) &&
      ValidateMailingAddressLine2(mailingAddressLine2) &&
      ValidateMailingAddressLine1(mailingAddressLine1) &&
      ValidateIsSeparateMailingAddress(isSeparateMailingAddress) &&
      ValidatePrincipalAddressZipCode(principalAddressZipCode) &&
      ValidatePrincipalAddressState(principalAddressState) &&
      ValidatePrincipalAddressCity(principalAddressCity) &&
      ValidatePrincipalAddressLine2(principalAddressLine2) &&
      ValidatePrincipalAddressLine1(principalAddressLine1) &&
      ValidatePrimaryBusiness(primaryBusiness) &&
      ValidateCompanyWithLLC(companyWithLLC) &&
      ValidateContributingToTheCompany() &&
      ValidateAmountOfCash(amountOfCash) &&
      ValidateIntellectualProperty(intellectualProperty) &&
      ValidateOtherAssets(otherAssets) &&
      ValidateOther(other)
    ) {
      const form = {
        id: id,
        customerServiceId: customerServiceId,
        companyWithLLC: companyWithLLC,
        primaryBusiness: primaryBusiness,
        principalAddressLine1: principalAddressLine1,
        principalAddressLine2: principalAddressLine2,
        principalAddressCity: principalAddressCity,
        principalAddressState: principalAddressState,
        principalAddressZipCode: principalAddressZipCode,
        isSeparateMailingAddress: isSeparateMailingAddress,
        mailingAddressLine1: mailingAddressLine1,
        mailingAddressLine2: mailingAddressLine2,
        mailingAddressCity: mailingAddressCity,
        mailingAddressState: mailingAddressState,
        mailingAddressZipCode: mailingAddressZipCode,
        ownerFirstName: ownerFirstName,
        ownerLastName: ownerLastName,
        preferredContactEmailForBusiness: preferredContactEmailForBusiness,
        preferredContactEmailForReceivingUpdates:
          preferredContactEmailForReceivingUpdates,
        preferredPhoneNumber: preferredPhoneNumber,
        isEffectiveDateForCreating: isEffectiveDateForCreating,
        effectiveDateForLLC: effectiveDateForLLC,
        reasonForEffectiveDate: reasonForEffectiveDate,
        perpetualTermForTheLLC: perpetualTermForTheLLC,
        termOfLLC: termOfLLC,
        reasonTermOfLLC: reasonTermOfLLC,
        isCash: isCash,
        amountOfCash: amountOfCash,
        isIntellectualProperty: isIntellectualProperty,
        intellectualProperty: intellectualProperty,
        isOtherAssets: isOtherAssets,
        otherAssets: otherAssets,
        isService: isService,
        isOther: isOther,
        other: other,
        haveIntellectualProperty: haveIntellectualProperty,
        describeIntellectualProperty: describeIntellectualProperty,
        optionForRegisteredAgent: optionForRegisteredAgent,
        otherRegisteredAgent: otherRegisteredAgent,
        isSubmitted: isSubmitted,
      };
      if (form.id === "") {
        singleMemberLLCServices
          .AddCustomerServiceSingleMemberLLCQuestion(form)
          .then((response) => {
            if (response.status) {
              if (isSubmitted) {
                notification.success({
                  message: "Submitted successfully!",
                });
              } else {
                notification.success({
                  message: "Saved Successfully!",
                });
              }
              setTimeout(() => {
                navigate("/dashboard");
              }, 2000);
              setShow(false);
            } else {
              setShow(false);
            }
          })
          .catch((error) => {
            notification.error({
              message: error.response.data.Message,
            });
            console.log(error);
            setShow(false);
          });
      } else {
        singleMemberLLCServices
          .UpdateCustomerServiceSingleMemberLLCQuestion(form)
          .then((response) => {
            if (response.status) {
              if (isSubmitted) {
                notification.success({
                  message: "Submitted successfully!",
                });
              } else {
                notification.success({
                  message: "Saved Successfully!",
                });
              }
              setTimeout(() => {
                navigate("/dashboard");
              }, 2000);
              setShow(false);
            } else {
              setShow(false);
            }
          })
          .catch((error) => {
            notification.error({
              message: error.response.data.Message,
            });
            console.log(error);
            setShow(false);
          });
      }
    } else {
      setShow(false);
    }
  };
  return (
    <>
      <Lodder show={show} />
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container my-5 pt-3">
            <div className="row mb-4">
              <div className="col-lg-12">
                {readOnly && (
                  <div className="content-box">
                    <h2 className="text-dark content-title">Note</h2>
                    <p>
                      Your information has been submitted and is being reviewed
                      by Foundry Legal Tools staff.
                    </p>
                  </div>
                )}
                <div className="content-box ">
                  <h2 className="text-dark content-title">
                    Start a Single-Member Washington State LLC
                  </h2>
                  <p>
                    The following form contains questions needed to get your LLC
                    started. It is divided into sections and asks questions to
                    provide us the information necessary for:
                  </p>
                  <p>1. Filing an LLC Certificate of Formation;</p>
                  <p>2. Making an "Initial Report" for your LLC; and</p>
                  <p>3. Drafting internal documentation for your company.</p>
                  <p>
                    <strong>UPDATE NOTICE:</strong> As of January 1, 2024, all
                    new companies are required to file a "Beneficial Owner"
                    Information (BOI) Report with FinCEN within 90 days of
                    formation. Since Foundry Law Group is forming your LLC, we will also need
                    to be listed in the BOI Report, as the "company applicant."
                    This form does not address the BOI Report filing
                    requirement, which will need to be handled separately.
                    We will follow-up with you on services we provide or
                    how you may handle the BOI Report filing yourself. See{" "}
                    <a href="https://www.fincen.gov/boi" target="_blank">
                       here{" "}
                    </a>
                    for more details on the BOI Report and filing requirements.
                  </p>
                  <span className="d-block">Thanks,</span>
                  <span>Foundry Law Group</span>
                </div>

                <div className="content-box pt-4">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">
                        Enter the name of your company below (to be followed
                        with ", LLC").<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={companyWithLLC}
                        onChange={handleCompanyWithLLC}
                        readOnly={readOnly}
                      />
                      {!companyWithLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {companyWithLLCValidation.message}
                        </div>
                      )}
                      <span>
                        E.g., Company Name, LLC. For an LLC, "Inc." is not
                        allowed in a name however it must contain the words
                        "limited liability company," or the abbreviation "L.L.C"
                        or "LLC."
                      </span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is going to be the LLC's primary business?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={primaryBusiness}
                        onChange={handlePrimaryBusiness}
                        readOnly={readOnly}
                      />
                      {!primaryBusinessValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {primaryBusinessValidation.message}
                        </div>
                      )}
                      <span>
                        Please briefly describe the business and the goods and/or
                        services you intend to provide (e.g., online retailing,
                        business consulting, etc.)
                      </span>
                    </div>
                    <div className="row mb-3">
                      <label className="form-label">
                        What will be the principal address of the business?
                        <span>*</span>
                      </label>
                      <div className="col">
                        <label className="form-label">Address Line 1</label>
                        <input
                          type="text"
                          className="form-control"
                          value={principalAddressLine1}
                          onChange={handlePrincipalAddressLine1}
                          readOnly={readOnly}
                        />
                        {!principalAddressLine1Validation.isValid && (
                          <div style={{ color: "red" }}>
                            {principalAddressLine1Validation.message}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label">Address Line 2</label>
                        <input
                          type="text"
                          className="form-control"
                          value={principalAddressLine2}
                          onChange={handlePrincipalAddressLine2}
                          disabled={readOnly}
                        />
                        {!principalAddressLine2Validation.isValid && (
                          <div style={{ color: "red" }}>
                            {principalAddressLine2Validation.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          value={principalAddressCity}
                          onChange={handlePrincipalAddressCity}
                          disabled={readOnly}
                        />
                        {!principalAddressCityValidation.isValid && (
                          <div style={{ color: "red" }}>
                            {principalAddressCityValidation.message}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label">State</label>
                        <Select
                          type="text"
                          value={principalAddressState}
                          onChange={handlePrincipalAddressState}
                          disabled={readOnly}
                          options={usStates}
                        />
                        {!principalAddressStateValidation.isValid && (
                          <div style={{ color: "red" }}>
                            {principalAddressStateValidation.message}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label">ZIP Code</label>
                        <input
                          type="text"
                          className="form-control"
                          value={principalAddressZipCode}
                          onChange={handlePrincipalAddressZipCode}
                          disabled={readOnly}
                        />
                        {!principalAddressZipCodeValidation.isValid && (
                          <div style={{ color: "red" }}>
                            {principalAddressZipCodeValidation.message}
                          </div>
                        )}
                      </div>

                      <span className="mt-1">
                        Note: The place of business is an address for the LLC
                        where the primary business will be conducted. This can
                        be your home address, but will be listed as a public
                        record with the state. The address must be a physical
                        street address. A P.O. Box or PMB will not be accepted.
                        If the address is not in WA State, please note that
                        other state's business licenses may be required. Please
                        enter the full address, city, state, and zip code.
                      </span>
                    </div>
                  </form>
                </div>

                <div className="content-box pt-4">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">
                        Is there a separate mailing address for the business?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isSeparateMailingAddress"
                          id="flexRadioDefault4"
                          value={true}
                          checked={isSeparateMailingAddress === "true"}
                          onChange={handleIsSeparateMailingAddress}
                          disabled={readOnly}
                        />

                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isSeparateMailingAddress"
                          id="flexRadioDefault5"
                          value={false}
                          checked={isSeparateMailingAddress === "false"}
                          onChange={handleIsSeparateMailingAddress}
                          disabled={readOnly}
                        />

                        <label className="form-check-label">No</label>
                      </div>
                      {!isSeparateMailingAddressValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {isSeparateMailingAddressValidation.message}
                        </div>
                      )}
                    </div>
                    {isSeparateMailingAddress === "true" && (
                      <div className="mb-3">
                        <div className="row mb-3">
                          <label className="form-label">
                            What will be the mailing address of the business?
                            <span>*</span>
                          </label>
                          <div className="col">
                            <label className="form-label">Address Line 1</label>
                            <input
                              type="text"
                              className="form-control"
                              value={mailingAddressLine1}
                              onChange={handleMailingAddressLine1}
                              disabled={readOnly}
                            />
                            {!mailingAddressLine1Validation.isValid && (
                              <div style={{ color: "red" }}>
                                {mailingAddressLine1Validation.message}
                              </div>
                            )}
                          </div>
                          <div className="col">
                            <label className="form-label">Address Line 2</label>
                            <input
                              type="text"
                              className="form-control"
                              value={mailingAddressLine2}
                              onChange={handleMailingAddressLine2}
                              disabled={readOnly}
                            />
                            {!mailingAddressLine2Validation.isValid && (
                              <div style={{ color: "red" }}>
                                {mailingAddressLine2Validation.message}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col">
                            <label className="form-label">City</label>
                            <input
                              type="text"
                              className="form-control"
                              value={mailingAddressCity}
                              onChange={handleMailingAddressCity}
                              disabled={readOnly}
                            />
                            {!mailingAddressCityValidation.isValid && (
                              <div style={{ color: "red" }}>
                                {mailingAddressCityValidation.message}
                              </div>
                            )}
                          </div>
                          <div className="col">
                            <label className="form-label">State</label>
                            <Select
                              type="text"
                              value={mailingAddressState}
                              onChange={handleMailingAddressState}
                              disabled={readOnly}
                              options={usStates}
                            />
                            {!mailingAddressStateValidation.isValid && (
                              <div style={{ color: "red" }}>
                                {mailingAddressStateValidation.message}
                              </div>
                            )}
                          </div>
                          <div className="col">
                            <label className="form-label">ZIP Code</label>
                            <input
                              type="text"
                              className="form-control"
                              value={mailingAddressZipCode}
                              onChange={handleMailingAddressZipCode}
                              disabled={readOnly}
                            />
                            {!mailingAddressZipCodeValidation.isValid && (
                              <div style={{ color: "red" }}>
                                {mailingAddressZipCodeValidation.message}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row mb-3">
                      <label className="form-label">
                        Owner Name<span>*</span>
                      </label>
                      <div className="col">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={ownerFirstName}
                          onChange={handleOwnerFirstName}
                          disabled={readOnly}
                        />
                        {!ownerFirstNameValidation.isValid && (
                          <div style={{ color: "red" }}>
                            {ownerFirstNameValidation.message}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={ownerLastName}
                          onChange={handleOwnerLastName}
                          disabled={readOnly}
                        />
                        {!ownerLastNameValidation.isValid && (
                          <div style={{ color: "red" }}>
                            {ownerLastNameValidation.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is the preferred contact email for the business, to
                        be filed with the Secretary of State?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={preferredContactEmailForBusiness}
                        onChange={handlePreferredContactEmailForBusiness}
                        disabled={readOnly}
                      />
                      {!preferredContactEmailForBusinessValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {preferredContactEmailForBusinessValidation.message}
                        </div>
                      )}
                      <span>Note: This is a matter of public record.</span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is the preferred email address for receiving
                        updates from Foundry Law Group?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={preferredContactEmailForReceivingUpdates}
                        onChange={
                          handlePreferredContactEmailForReceivingUpdates
                        }
                        disabled={readOnly}
                      />
                      {!preferredContactEmailForReceivingUpdatesValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {
                            preferredContactEmailForReceivingUpdatesValidation.message
                          }
                        </div>
                      )}
                      <span>
                        E.g., regarding formation, sending company documents,
                        etc.
                      </span>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        What is the preferred phone number for the business?
                        <span>*</span>
                      </label>
                      <InputMask
                        mask="(999) 999-9999"
                        type="text"
                        className="form-control"
                        value={preferredPhoneNumber}
                        onChange={handlePreferredPhoneNumber}
                        readOnly={readOnly}
                      />
                      {!preferredPhoneNumberValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {preferredPhoneNumberValidation.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Will the effective date for creating the LLC be the date
                        of filing?<span>*</span>
                      </label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isEffectiveDateForCreating"
                          id="flexRadioDefault6"
                          value={true}
                          checked={isEffectiveDateForCreating === "true"}
                          onChange={handleIsEffectiveDateForCreating}
                          disabled={readOnly}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isEffectiveDateForCreating"
                          id="flexRadioDefault7"
                          value={false}
                          checked={isEffectiveDateForCreating === "false"}
                          onChange={handleIsEffectiveDateForCreating}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">
                          No (if no, then you must enter a future date below)
                        </label>
                      </div>
                      {!isEffectiveDateForCreatingValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {isEffectiveDateForCreatingValidation.message}
                        </div>
                      )}
                      <span>
                        The default (and most common) effective date for the
                        company is the date of filing. If you would like to
                        specify a different future (cannot be retroactive) date
                        please specify the date and reason for specifying a
                        different date below.
                      </span>
                    </div>
                    {isEffectiveDateForCreating === "false" && (
                      <>
                        {" "}
                        <div className="mb-3">
                          <label className="form-label">
                            What will be the effective date for the LLC?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={effectiveDateForLLC}
                            onChange={handleEffectiveDateForLLC}
                            readOnly={readOnly}
                          />
                          {!effectiveDateForLLCValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {effectiveDateForLLCValidation.message}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            What is the reason for selecting a future effective
                            date for the LLC?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={reasonForEffectiveDate}
                            onChange={handleReasonForEffectiveDate}
                            readOnly={readOnly}
                          />
                          {!reasonForEffectiveDateValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {reasonForEffectiveDateValidation.message}
                            </div>
                          )}
                          <span>
                            A future date for effectiveness is not very common
                            and only appropriate when there is a specific
                            reason, please indicate the reason you would like a
                            future effective date.
                          </span>
                        </div>
                      </>
                    )}
                    <div className="mb-3">
                      <label className="form-label">
                        By default an LLC is formed to be perpetual (annual
                        renewals still required). In limited cases, a defined
                        term for the LLC may be selected. Please select one of
                        the following option?<span>*</span>
                      </label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="perpetualTermForTheLLC"
                          id="flexRadioDefault6"
                          value={1}
                          checked={perpetualTermForTheLLC === "1"}
                          onChange={handlePerpetualTermForTheLLC}
                          disabled={readOnly}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Standard perpetual duration
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="perpetualTermForTheLLC"
                          id="flexRadioDefault7"
                          value={2}
                          checked={perpetualTermForTheLLC === "2"}
                          onChange={handlePerpetualTermForTheLLC}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">
                          Time limited (enter time and reason below)
                        </label>
                      </div>
                      {!perpetualTermForTheLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {perpetualTermForTheLLCValidation.message}
                        </div>
                      )}
                      <span>
                        A defined term for an LLC is not typical and only for
                        special circumstances. A standard perpetual term LLC can
                        still be dissolved.
                      </span>
                    </div>
                    {perpetualTermForTheLLC === "2" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            What would you like to be the term of the LLC (enter
                            in years or a set end date)?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={termOfLLC}
                            onChange={handleTermOfLLC}
                            readOnly={readOnly}
                          />
                          {!termOfLLCValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {termOfLLCValidation.message}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            What is the reason for selecting a defined term for
                            the LLC?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={reasonTermOfLLC}
                            onChange={handleReasonTermOfLLC}
                            readOnly={readOnly}
                          />
                          {!reasonTermOfLLCValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {reasonTermOfLLCValidation.message}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    <div className="mb-3">
                      <label className="form-label">
                        What will you be contributing to the company(Select all that apply)?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="isCash"
                          checked={isCash}
                          onChange={handleIsCash}
                          disabled={readOnly}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Cash
                        </label>
                      </div>
                      
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="isOtherAssets"
                          checked={isOtherAssets}
                          onChange={handleIsOtherAssets}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">
                          Other Assets (e.g., domain name, personal tangible
                          assets)
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="isService"
                          checked={isService}
                          onChange={handleIsService}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">Services 
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="isIntellectualProperty"
                          checked={isIntellectualProperty}
                          onChange={handleIsIntellectualProperty}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">
                          Special Intellectual Property (any patents, registered trademarks, or specific technology or creative work) [Note that general business IP does not need to be listed.]
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="isOther"
                          checked={isOther}
                          onChange={handleIsOther}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">Other:</label>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="other"
                        value={other}
                        onChange={handleOther}
                        disabled={readOnly}
                      />
                      {!otherValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {otherValidation.message}
                        </div>
                      )}
                      <span>
                        We recommend contributing a minimum amount of $100
                        (i.e., an amount around what would be needed to open a
                        bank account) to the company in exchange for your
                        ownership of the company.
                      </span>
                      {!contributingToTheCompanyValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {contributingToTheCompanyValidation.message}
                        </div>
                      )}
                    </div>
                    {isCash && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            Amount of cash:
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={amountOfCash}
                            onChange={handleAmountOfCash}
                            disabled={readOnly}
                          />
                          {!amountOfCashValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {amountOfCashValidation.message}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {isIntellectualProperty && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            Briefly describe the special intellectual property:
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={intellectualProperty}
                            onChange={handleIntellectualProperty}
                            disabled={readOnly}
                          />
                          {!intellectualPropertyValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {intellectualPropertyValidation.message}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {isOtherAssets && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            Briefly describe the other assets:
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={otherAssets}
                            onChange={handleOtherAssets}
                            disabled={readOnly}
                          />
                          {!otherAssetsValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {otherAssetsValidation.message}
                            </div>
                          )}
                          <span>
                            E.g., list any domain names, or tangible assets (not
                            including a personal phone or computer)
                          </span>
                        </div>
                      </>
                    )}
                    <div className="mb-3">
                      <label className="form-label">
                        Do you have any intellectual property that relates to
                        the business of the company that won't be assigned to it
                        as a contribution?<span>*</span>
                      </label>
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="haveIntellectualProperty"
                          value={true}
                          checked={haveIntellectualProperty === "true"}
                          onChange={handleHaveIntellectualProperty}
                          disabled={readOnly}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="haveIntellectualProperty"
                          value={false}
                          checked={haveIntellectualProperty === "false"}
                          onChange={handleHaveIntellectualProperty}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">No</label>
                      </div>
                      <span>
                        E.g., intellectual property of a different, related
                        business or project
                      </span>
                      {!haveIntellectualPropertyValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {haveIntellectualPropertyValidation.message}
                        </div>
                      )}
                    </div>
                    {haveIntellectualProperty === "true" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            Briefly describe the intellectual property:
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={describeIntellectualProperty}
                            onChange={handleDescribeIntellectualProperty}
                            disabled={readOnly}
                          />
                          {!describeIntellectualPropertyValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {describeIntellectualPropertyValidation.message}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </form>
                </div>

                <div className="content-box">
                  <h2 className="text-dark content-title">Registered Agent</h2>
                  <p>
                    All entities must have a Registered Agent in Washington
                    State. The Registered Agent can be an individual (such as a
                    member) or a service provider. Foundry Law Group offers one
                    year of registered agent service as part of our formation
                    package ($250/year after the initial year).
                  </p>
                </div>

                <div className="content-box pt-4">
                  <label>
                    Please select one of the following option for your registered agent.
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="optionForRegisteredAgent"
                      id="flexRadioDefault1"
                      value={1}
                      checked={optionForRegisteredAgent === "1"}
                      onChange={handleOptionForRegisteredAgent}
                      disabled={readOnly}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Foundry Law Group as Registered Agent (initial year is
                      included in formation flat fee)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="optionForRegisteredAgent"
                      id="flexRadioDefault2"
                      value={2}
                      checked={optionForRegisteredAgent === "2"}
                      onChange={handleOptionForRegisteredAgent}
                      disabled={readOnly}
                    />
                    <label className="form-check-label">
                      I'll serve as Registered Agent using the address listed
                      above (Note this address will be publicly listed)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="optionForRegisteredAgent"
                      id="flexRadioDefault3"
                      value={3}
                      checked={optionForRegisteredAgent === "3"}
                      onChange={handleOptionForRegisteredAgent}
                      disabled={readOnly}
                    />
                    <label className="form-check-label">
                      Other Registered Agent -NOTE: please fill the next section
                      with name, address, and number
                    </label>
                  </div>
                  {!optionForRegisteredAgentValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {optionForRegisteredAgentValidation.message}
                    </div>
                  )}
                  {optionForRegisteredAgent === "3" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Other Registered Agent (our preferred vendor is RASi if
                        you would like to use a corporate service provider)
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={otherRegisteredAgent}
                        onChange={handleOtherRegisteredAgent}
                        readOnly={readOnly}
                      />
                      {!otherRegisteredAgentValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {otherRegisteredAgentValidation.message}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {!readOnly && (
                  <div className="d-flex justify-content-center mb-3">
                    <button
                      onClick={() => {
                        Modal.confirm({
                          content:
                            "You will lose unsaved changes. Do you want to continue?",
                          title: (
                            <div style={{ position: "relative" }}>
                              <span>Warning</span>
                              <CloseOutlined
                                style={{
                                  position: "absolute",
                                  top: "-8px",
                                  right: "-10px",
                                }}
                                onClick={() => {
                                  Modal.destroyAll();
                                }}
                              />
                            </div>
                          ),
                          footer: (_, { OkBtn }) => (
                            <>
                              <Button
                                className="submit-button text-white"
                                onClick={() => {
                                  navigate(-1);
                                  Modal.destroyAll();
                                }}
                              >
                                YES
                              </Button>
                              <Button
                                className="btn-submit-secondary"
                                onClick={() => {
                                  Modal.destroyAll();
                                }}
                              >
                                NO
                              </Button>
                            </>
                          ),
                        });
                      }}
                      className="btn-submit-secondary btn me-3"
                    >
                      CANCEL
                    </button>
                    <button
                      className="btn-submit-secondary btn me-3"
                      onClick={() => {
                        setToggle(toggle + 1);
                        setIsSubmitted(false);
                      }}
                    >
                      SAVE AS DRAFT
                    </button>
                    <button
                      className="submit-button btn"
                      onClick={() => {
                        handleOpen();
                      }}
                    >
                      SAVE AND SUBMIT
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <------------------------Modal for submit confiromation----------------> */}
      <Modal
        centered
        visible={open}
        onCancel={handleCancel}
        footer={[
          <Button
            className="btn-submit-secondary "
            key="back"
            onClick={handleCancel}
          >
            CANCEL
          </Button>,
          <Button className="submit-button " key="back" onClick={handleOk}>
            OK
          </Button>,
        ]}
      >
        <div className="row">
          <div className="col">
            <h6>
              Once submitted, you will not be able to make changes.
              <br /> Please confirm the information.
            </h6>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default SingleMemberLLCForm;
